var render, staticRenderFns
import script from "./HorizontalBar.vue?vue&type=script&lang=js&"
export * from "./HorizontalBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8d3a37')) {
      api.createRecord('3a8d3a37', component.options)
    } else {
      api.reload('3a8d3a37', component.options)
    }
    
  }
}
component.options.__file = "src/core/components/charts/HorizontalBar.vue"
export default component.exports